module.exports = __webpack_public_path__ + "static/media/crocodile(33).4a0e0ea0.PNG";